import { GraphUtils } from '@helpers/graph.helper';
import { Sensor } from '../sensor/sensor';
import { Router } from '@angular/router';
import { UtilsHelper } from '@helpers/utils.helper';

export class MatricPotentialAttribute extends Sensor {
  public matricPotentialChart: any;
  private matricPotentialSensor: any[];
  public iconsToDisplay: { icon: string, type: number }[] = [];

  constructor(router: Router, url: string, alertsActive: boolean) {
    super(router, url, alertsActive);
    this.matricPotentialChart = null;
    this.matricPotentialSensor = [];
  }

  private ensureArraySize(arr: any[], position: number): void {
    while (arr.length <= position) {
      arr.push([]);
    }
  }

  public prepareData(): void {
    const iconMap = new Map<string, { icon: string, type: number }>();
    for (const element of this.data) {
      const date = new Date(element.date);
      const timestamp = GraphUtils.getDateUtc(date);
      const position = element.position;
      const sensorInfo = UtilsHelper.nameSensor(element.type);
      const icon = sensorInfo.icon;

      if (!iconMap.has(icon)) {
        iconMap.set(icon, {
          icon,
          type: element.type
        });
      }

      this.ensureArraySize(this.matricPotentialSensor, position);
      this.matricPotentialSensor[position].push([timestamp, element.matricPotential]);
    }
    this.iconsToDisplay = Array.from(iconMap.values());
  }

  public setCharts(): void {
    const filteredMatricPotential = this.matricPotentialSensor.filter(series => series.length > 0);

    const positionNodeMatricPotential = this.matricPotentialSensor
      .map((item, index) => (item.length > 0 ? index + 1 : -1))
      .filter(index => index !== -1);

    this.matricPotentialChart = this.getConfigChar(
      'matricPotential',
      this.getChartSeriesNewNode('Sensor', filteredMatricPotential, positionNodeMatricPotential),
      this.getRanges('matricPotential'),
      this.getLimits('matricPotential')
    );
  }

  public hasMatricPotentialSensor(pos: number): boolean {
    const index = pos - 1;
    return (
      index >= 0 &&
      index < this.matricPotentialSensor.length &&
      this.matricPotentialSensor[index].length > 0
    );
  }

  public getMatricPotentialSensor(pos: number): any {
    const index = pos - 1;
    if (index >= 0 && index < this.matricPotentialSensor.length) {
      const sensorData = this.matricPotentialSensor[index];
      if (sensorData.length > 0) {
        return sensorData[sensorData.length - 1][1] ?? null;
      }
    }
    return null;
  }

  public static getVariables(): any[] {
    return [
      { title: 'Tensión Matricial', value: 'matricPotential' }
    ];
  }
}
